import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Row } from 'reactstrap';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';

//Components
import CardRelatorio from '../components/CardRelatorio';
import MainCard from '../../../components/MainCard/MainCard';


export default function RelatorioResumoMovimentoMensal({ dadosRelatorio, btnVoltar, filtros }) {
  const { setupVariavel, session } = useAuth();

  //Referencia do relatorio para impressão pdf
  const refRelatorio = useRef(null);

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersEntradasAvulsas = [
    { value: "Modalidade", objectValue: "modalidade", col: "8" },
    { value: "Data Entrada", objectValue: "dataEntrada", col: "4" },
    { value: "Placa", objectValue: "placa", col: "4" },
    { value: "Peso Entrada", objectValue: "pesoEntrada", col: "4" },
    { value: "Peso Saida", objectValue: "pesoSaida", col: "4" },
  ];

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersManejoResiduos = [
    { value: "Modalidade", objectValue: "modalidade", col: "8" },
    { value: "Data Hora", objectValue: "dataHora", col: "4" },
    { value: "Tipo de Manejo", objectValue: "tipoManejo", col: "8" },
    { value: "Peso", objectValue: "peso", col: "4" },
  ];

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersRedestinacoes = [
    { value: "Modalidade", objectValue: "modalidade", col: "8" },
    { value: "Data Hora", objectValue: "dataHora", col: "4" },
    { value: "Destino", objectValue: "destino", col: "8" },
    { value: "Peso Destinado", objectValue: "pesoDestinado", col: "4" },
  ];

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersColetasRecebidas = [
    { value: "Modalidade", objectValue: "modalidade", col: "8" },
    { value: "Data Hora", objectValue: "dataHora", col: "4" },
    { value: "Transportador", objectValue: "transportador", col: "8" },
    { value: "Peso Destinado", objectValue: "pesoDestinado", col: "4" },
  ];

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersEntradasRedestinacoes = [
    { value: "Modalidade", objectValue: "modalidade", col: "8" },
    { value: "Data Hora", objectValue: "dataHora", col: "4" },
    { value: "Transportador", objectValue: "transportador", col: "8" },
    { value: "Peso Destinado", objectValue: "pesoDestinado", col: "4" },
  ];


  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: "Relatório de redestinações",
  });


  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>
        {setupVariavel?.logoTipo &&
          <div className="d-flex align-items-center justify-content-center">
            <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
          </div>
        }
        <div className="header">
          <h4 className='text-black'>Resumo de Movimento Mensal</h4>
          <Row>
            <div className='col-6'>
              <p><span className="fw-bold">Destino:</span> {session?.acesso?.acesso_descricao}</p>
            </div>
            <div className='col-4'>
              {filtros.modalidadeId_selected
                ?
                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                :
                <p><span className="fw-bold">Modalidade:</span> Todas</p>
              }
            </div>
            <div className='col-6'>
              <p><span className="fw-bold">Mês/Ano:</span> {filtros.mesAno}</p>
            </div>
          </Row>
        </div>
        <div className="body">
          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Coletas Recebidas</h5>
          <CardRelatorio
            headers={headersColetasRecebidas}
            items={dadosRelatorio?.balancoMassaColeta ?? []}
          />

          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Entradas Avulsas</h5>
          <CardRelatorio
            headers={headersEntradasAvulsas}
            items={dadosRelatorio?.balancoMassaDestinosEntradaAvulsa ?? []}
          />

          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Entradas de Redestinação</h5>
          <CardRelatorio
            headers={headersEntradasRedestinacoes}
            items={dadosRelatorio?.balancoMassaColetaRecebimentoRedestinacoes ?? []}
          />

          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Manejo de Resíduos</h5>
          <CardRelatorio
            headers={headersManejoResiduos}
            items={dadosRelatorio?.balancoMassaDestinosManejo ?? []}
          />

          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Redestinações</h5>
          <CardRelatorio
            headers={headersRedestinacoes}
            items={dadosRelatorio?.balancoMassaRedestinacoes ?? []}
          />

        </div>
      </div>
    </MainCard>
  );
}
